<template>
  <b-container fluid="lg">
    <b-row align-v="center">
      <b-col cols="1">
        <b-img :src="require('../assets/images/logo.png')" fluid alt="Domeo - assemblées"></b-img>
      </b-col>
      <b-col cols="6">{{ $t("footer.message") }}</b-col>
      <b-col cols="5" class="text-right">v{{ appVersion }}</b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      appVersion: process.env.VUE_APP_VERSION || "0.0.0",
    };
  },
};
</script>
